import SectionHeading from "./SectionHeading";
import { hotKeywords, hotRanking, topMovers } from "@/mocks/home";

const maxHeat = Math.max(...hotRanking.map((item) => item.heatValue));

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          badge="Ranking"
          title="51cg5 热门榜 · 话题排行"
          desc="按实时热度排序，每 5 分钟更新一次，排名先后与热度变化一眼看清。"
          linkText="查看完整榜单"
          linkHref="#ranking"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-6">
              <div className="mb-2 flex items-center justify-between border-b border-background-200/70 pb-3 text-xs font-medium text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                    <i className="ri-fire-line"></i>
                  </span>
                  实时热度榜
                </span>
                <span>热度值 / 24h 变化</span>
              </div>

              <div>
                {hotRanking.map((item) => {
                  const pct = Math.round((item.heatValue / maxHeat) * 100);
                  return (
                    <a
                      key={item.id}
                      href="#ranking"
                      className="group flex cursor-pointer items-center gap-3 border-b border-background-200/60 py-4 last:border-b-0 md:gap-4"
                    >
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black md:h-8 md:w-8 ${
                          item.rank <= 3 ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {item.rank}
                      </span>

                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2">
                          <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                            {item.title}
                          </h3>
                          <span className="hidden shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-900 sm:inline-block">
                            {item.category}
                          </span>
                        </div>
                        <p className="mt-1 line-clamp-1 text-xs text-foreground-600 md:text-sm">{item.summary}</p>
                        <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                          <div
                            className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                            style={{ width: `${pct}%` }}
                          />
                        </div>
                      </div>

                      <div className="w-16 shrink-0 text-right md:w-24">
                        <div className="whitespace-nowrap font-heading text-sm font-black text-accent-600 md:text-lg">
                          {item.heatText}
                        </div>
                        <div
                          className={`mt-0.5 flex items-center justify-end gap-0.5 whitespace-nowrap text-[11px] font-bold md:text-xs ${
                            item.rising ? "text-primary-600" : "text-secondary-500"
                          }`}
                        >
                          <span className="flex h-3 w-3 items-center justify-center">
                            <i className={item.rising ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                          </span>
                          {item.delta}
                        </div>
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className="ri-rocket-2-line text-sm"></i>
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">热度飙升榜</h3>
              </div>
              <ul className="mt-4 space-y-3">
                {topMovers.map((mover, index) => (
                  <li key={mover.id} className="flex items-center gap-3">
                    <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-background-50 font-heading text-xs font-black text-primary-600">
                      {index + 1}
                    </span>
                    <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">{mover.name}</span>
                    <span className="shrink-0 whitespace-nowrap text-xs font-bold text-accent-600">{mover.deltaText}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200/70 bg-background-100 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                  <i className="ri-price-tag-3-line text-sm"></i>
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950">热搜关键词</h3>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {hotKeywords.map((keyword) => (
                  <a
                    key={keyword}
                    href="#ranking"
                    className="cursor-pointer whitespace-nowrap rounded-full border border-secondary-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-secondary-900 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700"
                  >
                    #{keyword}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}